import React from 'react';
const rows: {
  problem: string;
  cost: string;
}[] = [{
  problem: 'Quoting “whatever feels right” on your first weddings',
  cost: '$1,000–$2,500 left on the table per event'
}, {
  problem: 'Rebuilding checklists, timelines and emails from scratch',
  cost: '100+ unpaid hours every year'
}, {
  problem: 'One forgotten detail on the big day',
  cost: 'Your reputation — in an industry that lives on referrals'
}, {
  problem: 'Vendors sensing you’re improvising',
  cost: 'They run your event (and your stress levels)'
}, {
  problem: 'No offboarding, no referral system',
  cost: 'Every wedding is a dead end instead of 3 new clients'
}];
export function CostOfInaction() {
  return <section className="w-full bg-ivory py-16 sm:py-24" data-id="element-76" data-mp="3imwurcid71v8">
      <div className="mx-auto max-w-4xl px-5" data-id="element-77" data-mp="3nn1ah0bg7ske">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-78" data-mp="3nocft4kjl8dm">
          What does &ldquo;winging it&rdquo; actually cost you?
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-79" data-mp="3egzk92yy1cxk" />

        <div className="mt-12 overflow-hidden border border-gold-soft bg-white" data-id="element-80" data-mp="39hd68rbajsnp">
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-81" data-mp="39jg1bprawbza">
            <div className="border-b border-gold-soft px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-ink-muted sm:border-r" data-id="element-82" data-mp="34j1ugb1fr82u">
              Without the system
            </div>
            <div className="hidden border-b border-gold-soft bg-blush-soft px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-blush-deep sm:block" data-id="element-83" data-mp="11tgi29twsde">
              The real cost
            </div>
          </div>

          {rows.map((row, index) => <div key={row.problem} className={`grid grid-cols-1 sm:grid-cols-2 ${index > 0 ? 'border-t border-gold-soft/70' : ''}`} data-id="element-84" data-mp="3nf1so3l0b7uv" data-mpi={index}>
              <p className="px-6 py-5 text-[15px] text-ink-soft sm:border-r sm:border-gold-soft/70" data-id="element-85" data-mp="jtw27s1buyui">
                {row.problem}
              </p>
              <p className="bg-blush-soft/50 px-6 py-5 text-[15px] font-medium text-blush-deep" data-id="element-86" data-mp="29a81bwoyc83g">
                {row.cost}
              </p>
            </div>)}
        </div>

        <p className="mt-12 text-center font-serif text-2xl italic sm:text-3xl text-ink" data-id="element-87" data-mp="1zk5b2497t88t">
          One properly priced wedding pays for this system 100 times over.
        </p>
        <p className="mt-4 text-center text-base text-gold-dark" data-id="element-88" data-mp="1qiyq9izj9b9r">
          Your next inquiry can go completely differently.
        </p>
      </div>
    </section>;
}